<template>
  <div class="landing-flow">
    <WlWizard
      :style="{
        backgroundImage: 'url(' + this.cms.page.steps.background_image + ')'
      }"
      :current-step="2"
      :steps="3"
      :current-percent="0"
      :first-name="firstName"
      :last-name="lastName"
      :step-completed-icon="stepCompletedIcon"
    >
      <template v-slot:content>
        <div
          class="landing-flow__body-content landing-flow__body-content--step2a"
          v-if="letter === 'a'"
        >
          <WlStep
            :header-icon="cms.page.steps.step_two_a.icon"
            :title="cms.page.steps.step_two_a.title"
            :sub-text="cms.page.steps.step_two_a.sub_text"
          />
          <div class="category-criminal" ref="categoryCriminal">
            <p class="category-criminal__header">
              <strong>{{ cms.page.steps.step_two_a.category_header }}</strong>
            </p>
            <div
              class="category-criminal__list"
              :style="[
                isMobile
                  ? {
                      transform: `translateX(${position}px) `,
                      transition: '.7s ease'
                    }
                  : ''
              ]"
            >
              <div
                class="wl-spinner-text-list wl-spinner-text-list--placeholder"
                v-if="!stepTwoACategories"
                v-for="item in categoriesTwoA"
              >
                <div class="wl-spinner-text-list__item">
                  <p class="wl-spinner-text-list__text">{{ item.title }}</p>
                </div>
              </div>
              <WlSpinnerTextList
                v-if="stepTwoACategories"
                :key="index"
                v-for="(item, index) in stepTwoACategories"
                :item="item"
                :index="index"
                :position="position"
                :list-width="listWidth"
                :checkColor="'#4476ff'"
                :spinner-color="'#ffc400'"
                :spinner-text-array="stepTwoACategories"
                @wl-spinner-text-list-finished="setStepLetter('b')"
                @wl-spinner-text-list-update-position="updatePosition"
              />
            </div>
          </div>
        </div>
        <div class="landing-flow__body-content" v-if="letter === 'b'">
          <div class="reports-available">
            <img
              :src="cms.page.steps.step_two_b.image"
              alt="step-two-b-image"
              class="reports-available__image"
            />
            <div class="reports-available__content">
              <WlStep :title="cms.page.steps.step_two_b.title" />
              <div class="reports-available__list">
                <div
                  v-if="step2bList"
                  v-for="item in step2bList"
                  :key="item.content"
                  class="reports-available__list-item"
                  :style="[
                    !item.isVisible
                      ? {
                          opacity: 0
                        }
                      : {
                          opacity: 1,
                          transition: '.7s ease'
                        }
                  ]"
                >
                  <tz-markdown :content="setNameInText(item.content)" />
                </div>
              </div>
            </div>
          </div>

          <button
            class="continue-btn"
            v-touch:tap="continueToStepThree"
            :style="[
              !shouldShowReportBtn
                ? {
                    opacity: 0
                  }
                : {
                    opacity: 1,
                    transition: '.7s ease'
                  }
            ]"
          >
            <span class="continue-btn__text">{{
              cms.page.steps.step_two_b.button_text
            }}</span>
          </button>
        </div>

        <div class="wl-wizard__privacy-banner">
          <tz-markdown
            class="wl-wizard__privacy-banner-text"
            :content="cms.page.steps.privacy_banner_text"
          />
        </div>
      </template>
    </WlWizard>
  </div>
</template>
<script>
import TzMarkdown from '@trazi/tz-markdown/src/tz-markdown.vue';
import WlWizard from '@/components/shared/wl-wizard';
import WlStep from '@/components/shared/wl-step';
import WlSpinnerTextList from '@/components/shared/wl-spinner-text-list';
import CompletedIcon from '@/assets/images/shared/check_success.svg';
import stepCompletedIcon from '@/assets/images/step-completed-icon.svg';
import landingHelper from '@/assets/js/landingHelper';
import searchSDK from '@/assets/js/shared/services/search-sdk';
import setTitleCase from '@/assets/js/shared/helpers/setTitleCase';
import { isSafe } from 'assets/js/validationHelper';
const NBars = require('nbars/commonjs.js');
const pageCms = require(`@/assets/cms/pages/landing.json`);

const { steps_page_title: pageTitle, steps_meta_root: metaRoot } = pageCms;

const categoryProps = {
  opacity: 0.3,
  setCheck: false,
  spinnerDelay: null,
  checkDelay: null,
  isStartingSpin: false
};

const categoriesTwoA = pageCms.steps.step_two_a.category_list.map(category => ({
  ...categoryProps,
  title: category.category_name
}));

// Set up Step A checkmark delays
for (let i = 0; i < categoriesTwoA.length; i++) {
  categoriesTwoA[i].spinnerDelay = i * pageCms.steps.step_two_a.spinner_delay;
  categoriesTwoA[i].checkDelay =
    i * pageCms.steps.step_two_a.spinner_delay + 2000;
}

const step2BListProps = {
  isVisible: false
};

const step2bList = pageCms.steps.step_two_b.list.map(item => ({
  ...step2BListProps,
  content: item.content
}));

export default {
  components: {
    WlWizard,
    WlStep,
    WlSpinnerTextList,
    TzMarkdown
  },
  data() {
    return {
      isMobile: false,
      position: 0,
      CompletedIcon,
      categoriesTwoA,
      step2bList,
      shouldShowReportBtn: false,
      letter: 'a',
      listWidth: null,
      stepCompletedIcon,
      mapBackgroundImage: '',
      stepTwoACategories: false,
      searchSDK,
      firstName: null,
      lastName: null,
      setTitleCase
    };
  },
  computed: {
    name() {
      return `${this.firstName} ${this.lastName}`;
    }
  },
  methods: {
    setFadeIn() {
      let idx = 1;
      let listLength = this.step2bList.length;

      for (let i = 0; i < listLength; i++) {
        setTimeout(() => {
          this.step2bList[i].isVisible = true;

          if (i === listLength - 1) {
            this.fadeInBtn();
          }
        }, idx++ * (this.$route.query.testing ? 100 : 900));
      }
    },
    fadeInBtn() {
      setTimeout(
        () => {
          this.shouldShowReportBtn = true;
        },
        this.$route.query.testing ? 100 : 980
      );
    },
    startStepA() {
      // Set checkmarks for page
      this.stepTwoACategories = categoriesTwoA;
    },
    setStepLetter(letter) {
      this.letter = letter;

      if (this.letter === 'b') {
        this.setFadeIn();
      }
    },
    updatePosition(value) {
      this.position = value;
    },
    setSpinnerDelay(amount, categoryType) {
      for (let i = 0; i < categoryType.length; i++) {
        categoryType[i].spinnerDelay = i * amount;
        categoryType[i].checkDelay = i * amount + 2000;
      }
    },
    continueToStepThree() {
      // navigates user to step 3A
      this.$router.push({
        name: 'flow.step3',
        query: this.$route.query
      });
    },
    onResizeWidth() {
      let windowSize = window.innerWidth;
      this.isMobile = windowSize < 426;
    },
    setNameInText(itemText) {
      return NBars.transform(itemText, {
        name: setTitleCase({ text: this.name })
      });
    }
  },
  props: {
    cms: {
      type: Object,
      default: () => {
        return {
          page: pageCms
        };
      }
    }
  },
  async validate({ params }) {
    return isSafe(params);
  },
  mounted() {
    this.startStepA();
    this.onResizeWidth();

    if (this.$refs.categoryCriminal) {
      this.listWidth = this.$refs.categoryCriminal.offsetWidth + 30;
    }

    let timeout;
    window.addEventListener(
      'resize',
      () => {
        if (timeout) {
          window.cancelAnimationFrame(timeout);
        }

        timeout = window.requestAnimationFrame(() => {
          this.onResizeWidth();
        });
      },
      false
    );

    landingHelper.checkUrlAndGetData(this);
  },
  async asyncData({ $bugsnag, query, route, redirect }) {
    if (!process.server) {
      return;
    }

    const clientHasData = query.cachedres && query.cachedres === 'true';

    if (clientHasData) {
      return {};
    }
    const landingId = route.params.landingID;
    const resultsUrl = NBars.transform(pageCms.steps.results_url, {
      landingId
    });
    const stepTwoUrl = NBars.transform(pageCms.steps.step_two_url, {
      landingId
    });

    return await landingHelper.getPayloadOrRedirect(
      searchSDK,
      stepTwoUrl,
      resultsUrl,
      redirect,
      route,
      query,
      {},
      $bugsnag
    );
  },
  watchQuery: ['cachedres'],
  head() {
    return landingHelper.getPageMetaAndTitle({
      city: this.$route.query.city,
      state: this.$route.query.state,
      firstName: this.$route.query.firstName,
      lastName: this.$route.query.lastName,
      stepNumber: 2,
      pageTitleCms: pageTitle,
      metaArr: metaRoot
    });
  }
};
</script>
